import { render, staticRenderFns } from "./Transfer.vue?vue&type=template&id=5efdd604&scoped=true"
import script from "./Transfer.vue?vue&type=script&lang=js"
export * from "./Transfer.vue?vue&type=script&lang=js"
import style0 from "./Transfer.vue?vue&type=style&index=0&id=5efdd604&prod&scoped=true&lang=css"
import style1 from "./Transfer.vue?vue&type=style&index=1&id=5efdd604&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efdd604",
  null
  
)

export default component.exports